module.exports = __webpack_public_path__ + "img/amboss.423d8a02.png";